<section class="about-page  section-b-space py-4">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h2>Notice of Privacy Practice of Ralba Technologies</h2>
                <p>This statement applies to &lsquo;Personal Information&rsquo; collected, processed, or stored by Ralba Technologies, Inc. This notice describes the extent of collection and usage by Ralba Technologies as an entity.</p>
                <h3>Why we collect and use information</h3>
                <p>We may use the information we collect for the following primary reasons:</p>
                <p>Product and Service Fulfillment</p>
                <ul>
                    <li aria-level="1">To complete, fulfill, manage, and communicate with you about transactions.</li>
                    <li aria-level="1">To establish your online profile on our platform.</li>
                    <li aria-level="1">To process your payments and address your order inquiries and requests.</li>
                </ul>
                <p>Marketing, Promotions, and Advertising</p>
                <ul>
                    <li aria-level="1">To deliver information about our products, services, and special offers.</li>
                    <li aria-level="1">To identify product preferences and shopping preferences.</li>
                    <li aria-level="1">To offer you additional products or services that may be of interest.</li>
                </ul>
                <p>Internal Operations</p>
                <ul>
                    <li aria-level="1">To improve the effectiveness of our platform.</li>
                    <li aria-level="1">To research and analyze our operations.</li>
                </ul>
                <p>Fraud Prevention, Security and Compliance</p>
                <ul>
                    <li aria-level="1">To protect our assets as well as the assets of the vendor partners who use our platform and prevent fraudulent transactions.</li>
                    <li aria-level="1">To validate your credentials and authenticate you when logging into the platform.</li>
                    <li aria-level="1">To protect the security and integrity of our service and data.</li>
                    <li aria-level="1">To assist law enforcement and respond to legal/regulatory inquiries.</li>
                </ul>
                <h3>Type of Information we collect</h3>
                <p>We collect a limited set of Personal Information such as identifiers, and payment information.</p>
                <p>Identifying information</p>
                <p>We collect this information when you create a profile, place an order or contact us via email. For example, name, address, Zip code, email address, telephone number.</p>
                <h3>How we collect your information</h3>
                <p>We collect information when you create a profile or when you make a purchase. Currently we do not track you in any way or drop cookies your browser.</p>
                <h3>How we share your information</h3>
                <p>We share your Personal Information with the vendors that display and sell on our platform just for the purpose of fulfillment.</p>
                <p>How we safeguard information collected</p>
                <p>Ralba Technologies have put in place various procedural and administrative measures to safeguard the information we collect and use. We designed our platform to accept orders only from web browsers that permit communication through a Secure
                    Socket Layer (SSL). SSL is an encryption standard that provides a layer of security while information is being transmitted over the Internet.</p>
                <p>As a matter of policy, we do not disclose details regarding our security measures as this could be beneficial information to criminals and other bad actors.</p>
            </div>
        </div>
    </div>
</section>
<!-- about section end -->